import i18n from "i18next";
import "../../../sass/components/BuyFlowBundle.scss";
import AddAndRemoveButtons from "@/Pages/BuyFlow/AddAndRemoveButtons";
import {useRef, useState} from "react";
import ShowFees from "@/Pages/BuyFlow/ShowFees";
import UsageFeeDescription from "@/Pages/BuyFlow/UsageFeeDescription";

export default function Bundle({state, dispatch}) {

    const [show, setShow] = useState(false);
    const target = useRef(null);

    const toolTipStatus = (openOrClose) => {
        dispatch({ type: "anyTooltipsOpen", payload: { anyTooltipsOpen: openOrClose }});
        setShow(openOrClose);
    }

    const overlap = (bundle) => {
        let customModulesInCart = state.cart.filter(item => item.type === "module");
        let bundleModulesInCart = state.cart.filter(item => item.type === "package").map(item => item.modules).flat();

        for(let i in customModulesInCart) {
            if(bundle.modules.map(module => module.productId).includes(customModulesInCart[i].productId)) {
                return true;
            }
        }

        for(let i in bundleModulesInCart) {
            if(bundle.modules.map(module => module.productId).includes(bundleModulesInCart[i].productId)) {
                if(!state.cart.includes(bundle)) {
                    return true;
                }
            }
        }

        return false;
    }

    return (
        <div>
            {state.bundles.filter(bundle => bundle.term === state.toggleValue).map((bundle, index) => {
                return <div className={`bundle ${overlap(bundle) ? "disabled-bundle" : ""}`} key={index}>
                    <div className="bundle-title">{bundle.name}</div>
                    <span className="bundle-price">${state.billingFrequency === "monthly" ? bundle.price : bundle.price * 12}</span>
                    <span className="per-month">/{state.billingFrequency === "monthly" ? i18n.t("buy-flow.month") : i18n.t("buy-flow.year")}</span>
                    {/*<ShowFees state={state} dispatch={dispatch} bundle={bundle} label={i18n.t("buy-flow.usage-fees")}/>*/}
                    <UsageFeeDescription description={bundle.usageFeesDescription}/>
                    <div className="bundle-modules">
                        {bundle.modules.map((module, key) => {
                            return (
                                <div key={key} className={`module-containers
                                    ${state.showFreeModule ? "" : "deleted-module"}`}>
                                    <img className="module-svg" alt={module.name} src={module.svg} />
                                        <span>{module.sales_name ?? module.name}</span>
                                            {module.required ?
                                                <span className="included">{i18n.t("buy-flow.included")}</span>
                                                : module.price !== 0 ? <span className="optional">
                                                    ${state.billingFrequency === "monthly" ? module.price : module.price * 12}
                                                        {state.billingFrequency === "monthly" ? i18n.t("buy-flow./mo") : i18n.t("buy-flow./yr")}
                                                    </span>
                                                    : <span className="optional">
                                            <strike className="optional-strike">
                                                ${state.billingFrequency === "monthly" ? module.original_price : module.original_price * 12}
                                                {state.billingFrequency === "monthly" ? i18n.t("buy-flow./mo") : i18n.t("buy-flow./yr")}
                                            </strike>&nbsp;&nbsp;{i18n.t("buy-flow.included")}
                                        </span>}
                                </div>
                            )
                        })}
                    </div>
                    <AddAndRemoveButtons
                        bundle={bundle}
                        disabled={overlap(bundle)}
                        state={state}
                        dispatch={dispatch} />
                </div>
            })}
        </div>

    )
}
